﻿import React, { useState } from 'react';
import { Box, Typography, Button, Select, MenuItem, FormControl, InputLabel, CircularProgress } from '@mui/material';
import { exportValidatedData } from '../../services/apiService';
import { toast } from 'react-toastify';

const ExportData = () => {
    const [format, setFormat] = useState('json_per_image');
    const [isLoading, setIsLoading] = useState(false);

    const handleExport = async () => {
        setIsLoading(true);
        try {
            // API call returns the data directly (or triggers download headers)
            const response = await exportValidatedData(format);

            // Trigger download
            const filename = format === 'csv_aggregate' ? 'validated_annotations.csv' : 'validated_annotations.json';
            const contentType = format === 'csv_aggregate' ? 'text/csv' : 'application/json';
            let dataToDownload;
            if (format === 'json_per_image') {
                if (response.jsonData) {
                    dataToDownload = JSON.stringify(response.jsonData, null, 2);
                } else {
                    // Fallback: read text from blob if apiService parsing failed
                    const jsonText = await response.data.text();
                    dataToDownload = jsonText; // Assume backend sent formatted JSON
                }
            } else { // CSV
                dataToDownload = response.data; // Use the blob directly for CSV
            }
            const data = dataToDownload;

            const blob = new Blob([data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            toast.success(`Data exported successfully as ${filename}`);

        } catch (err) {
            console.error("Export error:", err);
            const errMsg = err.response?.data?.error || 'Export failed. See console for details.';
            toast.error(`Export failed: ${errMsg}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box sx={{ mt: 3, p: 2, border: '1px dashed grey', borderRadius: 1 }}>
            <Typography variant="h6" gutterBottom>Export Validated Data</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                 <FormControl sx={{ minWidth: 200 }}>
                   <InputLabel id="export-format-label">Format</InputLabel>
                   <Select
                     labelId="export-format-label"
                     value={format}
                     label="Format"
                     onChange={(e) => setFormat(e.target.value)}
                     disabled={isLoading}
                   >
                     <MenuItem value="json_per_image">JSON (per image)</MenuItem>
                     <MenuItem value="csv_aggregate">CSV (aggregated)</MenuItem>
                   </Select>
                 </FormControl>
                <Button variant="contained" onClick={handleExport} disabled={isLoading}>
                     {isLoading ? <CircularProgress size={24} /> : 'Export Data'}
                </Button>
            </Box>
        </Box>
    );
};

export default ExportData;
